import { callGetApi, callPostApi } from "@/utils/apiWrapper";

const SHERLOCK_AUTH_API = {
  LOGIN: "/api/v1/sherlock/auth/login",
  CHECK_ID: "/api/v1/sherlock/auth/check-id", // + /:loginId
  SMS_SEND: "/api/v1/sherlock/auth/sms/send",
  SMS_VERIFY: "/api/v1/sherlock/auth/sms/verify",
  REGISTER: "/api/v1/sherlock/auth/register",
  FIND_ID: "/api/v1/sherlock/auth/find-id",
  RESET_PASSWORD: "/api/v1/sherlock/auth/reset-password",
};

export const state = {};

export const mutations = {};

export const actions = {
  /**
   * 셜록 아이디/비밀번호 로그인
   */
  async acSherlockLogin({ commit }, { loginId, password }) {
    const res = await callPostApi({
      url: SHERLOCK_AUTH_API.LOGIN,
      data: { loginId, password },
      commit,
    });
    if (res && res.access_token) {
      window.localStorage.setItem("naezip_to_ac_se", res.access_token);
      // refresh_token은 http-only 쿠키로 전달됨 (카카오 로그인과 동일).
    }
    return res;
  },

  /**
   * 아이디 중복 확인
   */
  async acSherlockCheckId({ commit }, loginId) {
    const res = await callGetApi({
      url: `${SHERLOCK_AUTH_API.CHECK_ID}/${loginId}`,
      params: {},
      commit,
    });
    return res;
  },

  /**
   * SMS 인증번호 발송
   */
  async acSherlockSmsSend({ commit }, { mobile, purpose }) {
    const res = await callPostApi({
      url: SHERLOCK_AUTH_API.SMS_SEND,
      data: { mobile, purpose },
      commit,
    });
    return res;
  },

  /**
   * SMS 인증번호 확인
   */
  async acSherlockSmsVerify({ commit }, { mobile, code, purpose }) {
    const res = await callPostApi({
      url: SHERLOCK_AUTH_API.SMS_VERIFY,
      data: { mobile, code, purpose },
      commit,
    });
    return res;
  },

  /**
   * 회원가입
   */
  async acSherlockRegister({ commit }, payload) {
    const res = await callPostApi({
      url: SHERLOCK_AUTH_API.REGISTER,
      data: payload,
      commit,
    });
    return res;
  },

  /**
   * 아이디 찾기
   */
  async acSherlockFindId({ commit }, { name, mobile }) {
    const res = await callPostApi({
      url: SHERLOCK_AUTH_API.FIND_ID,
      data: { name, mobile },
      commit,
    });
    return res;
  },

  /**
   * 비밀번호 재설정
   */
  async acSherlockResetPassword({ commit }, { name, mobile, newPassword }) {
    const res = await callPostApi({
      url: SHERLOCK_AUTH_API.RESET_PASSWORD,
      data: { name, mobile, newPassword },
      commit,
    });
    return res;
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
